import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m5.2 6.2 1.4 1.4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M2 13h2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M20 13h2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m17.4 7.6 1.4-1.4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M22 17H2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M22 21H2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 13a4 4 0 0 0-8 0", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 5V2.5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Haze";
const Haze = memo(themed(Icon));
export {
  Haze
};
//# sourceMappingURL=haze.js.map
